var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 3 54 55",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "svg_10a",
    width: 54,
    height: 55,
    x: 0,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M54 3H0v55H54z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg_10a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEEBF5",
    d: "M27.42 58.9c14.3 0 25.91-6.4 25.91-14.28s-11.6-14.28-25.91-14.28c-14.32 0-25.92 6.4-25.92 14.28 0 7.89 11.6 14.28 25.92 14.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0062AD",
    stroke: "#0062AD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m21.63 36.52 5.74-11.53c2.05-4.14 4.17-8.54 3.8-13.14-.18-2.21-1-4.46-2.69-5.9a7.62 7.62 0 0 0-3.9-1.7c-3.52-.5-7.16 1.13-9.44 3.84-2.28 2.7-3.27 6.35-3.11 9.88s1.4 6.96 3.16 10.02a51.36 51.36 0 0 0 6.44 8.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0062AD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26.23 4.56A32 32 0 0 0 24 3.36c-1.34-.64-2.8-1-4.28-1.04h-.03a6.02 6.02 0 0 0-2.43.44 14.74 14.74 0 0 0-8.72 9.97c-.18.7-.27 1.43-.27 2.16.01 1.99.34 3.97 1.02 5.84 1.67 4.59 4.44 8.77 7.46 12.7a7.02 7.02 0 0 0 2.78 2.15l2.09.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0062AD",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26 18.72c1.51-3.04.87-6.43-1.44-7.58-2.32-1.15-5.42.39-6.94 3.42-1.52 3.04-.87 6.44 1.44 7.58 2.31 1.15 5.42-.38 6.93-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0062AD",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.24 10.77c.87 1.58.86 3.87-.2 5.99-1.07 2.16-2.96 3.56-4.79 3.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0062AD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m21.69 36.36-3.76-1.45-5.09 5.99L2.06 43l17.7 10.45 10.77-2.33 7.63-7.92 7.12-.28 7.18-8.29-17.8-10.35-7.27 8.28-3.53-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0062AD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m12.92 40.91 17.57 10.2m-7.51-17.08 15.26 9.16M27.45 32.52 45.26 42.9"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-icon.c211330edfc98cca8e5e475ab4c3a439.svg";